<template>
	<div id="app" style="overflow: hidden;">
		<pano-view v-model="scene" path="./scenes/" @navigate="onNavigate" />
		<thumbs-view v-if="thu" :thumbs="_navigation_thumbs" @click="onNavigationThumbClick" />
		<svg-icon v-if="!thu" class="icon menu" width="32px" height="32px" icon="menu" @click="thu = true" /> 
		<svg-icon v-if="thu" class="icon menu" width="32px" height="32px" icon="close" @click="thu = false" />
		<info-view v-if="inf" :thumb="_info.image" :label="_info.title" :content="_info.content" :cta="_info.cta" />
		<svg-icon v-if="!inf" class="icon info" width="32px" height="32px" icon="info" @click="inf = !inf" />
		<svg-icon v-if="inf" class="icon info" width="32px" height="32px" icon="close" @click="inf = !inf" />
		<div class="logo">
			<img :src="'./img/logo.png'" class="logo" /><br>
			<div @click="lang = 'da'">Dansk</div>
			<div @click="lang = 'de'">Deutch</div>
			<div @click="lang = 'en'">English</div>
		</div>
		<div class="copyright">© 2020 Plethora</div>
	</div>
</template>

<script>
	import PanoView from './components/PanoView.vue';
	import ThumbsView from './components/ThumbsView.vue';
	import InfoView from './components/InfoView.vue';

	import da from './lang/da.json';
	import en from './lang/en.json';
	import de from './lang/de.json';

	export default {
		name: 'App',
		data() {
			return {
				lang: 'da',

				scene:		'top-1',
				info:		null,

				thumbs: false,


				navThumbs: [],

				preloads: [],

				thu: true,
				inf: true
			};
		},
		components: {
			PanoView,
			ThumbsView,
			InfoView
		},
		computed: {
			_l() {
				return {
					da: da,
					en: en,
					de: de
				}[this.lang];
			},
			_navigation_thumbs() {
				if (!this.thumbs) return [];

				var r = [];

				// Areas
				const top = {
					thumb: './img/map_thumb.jpg',
					label: this._l.phrases.site,
					value: 'top-1'
				};

				const apartments = {
					thumb: './img/apartments1_thumb.jpg',
					label: this._l.phrases.apartments,
					value: 'apartments-1-1'
				};

				const apartments1 = {
					thumb: './img/apartments1_thumb.jpg',
					label: this._l.apartments.apartment1,
					value: 'apartments-1-1'
				};

				const apartments2 = {
					thumb: './img/apartments2_thumb.jpg',
					label: this._l.apartments.apartment2,
					value: 'apartments-2-1'
				};

				const apartments3 = {
					thumb: './img/room1_thumb.jpg',
					label: this._l.apartments.room1,
					value: 'apartments-3-1'
				};

				const apartments4 = {
					thumb: './img/room2_thumb.jpg',
					label: this._l.apartments.room2,
					value: 'apartments-4-1'
				};

				/*const tents = {
					thumb: './img/tents_thumb.jpg',
					label: this._l.phrases.tents,
					value: 'tent-1'
				};*/

				const huts = {
					thumb: './img/huts_thumb.jpg',
					label: this._l.phrases.huts,
					value: 'hut-1'
				};

				const utils = {
					thumb: './img/utilities_thumb.jpg',
					label: this._l.phrases.utils,
					value: 'utils-hallway'
				};

				const kitchen = {
					thumb: './img/kitchen_thumb.jpg',
					label: this._l.phrases.kitchen,
					value: 'kitchen'
				};

				const shop = {
					thumb: './img/shop_thumb.jpg',
					label: this._l.phrases.shop,
					value: 'shop'
				};

				// Groups
				if (['top-1', 'top-2', 'top-3', 'beach-playground', 'playground', 'site', 'orangery'].includes(this.scene)) {
					r = [apartments, huts, utils];
				}

				if (['tent-1', 'tent-2', 'tent-3'].includes(this.scene)) {
					r = [top];
				}

				if (['utils-hallway', 'utils-toilet', 'utils-bath', 'utils-bath-3', 'kitchen', 'shop'].includes(this.scene)) {
					r = [top, shop, kitchen, utils];
				}

				if (['hut-1', 'hut-2'].includes(this.scene)) {
					r = [top];
				}

				if (['apartments-1-1', 'apartments-1-2', 'apartments-1-3', 'apartments-1-4', 'apartments-1-5', 'apartments-1-6', 'apartments-2-1', 'apartments-2-2', 'apartments-2-3', 'apartments-2-4', 'apartments-3-1', 'apartments-3-2', 'apartments-4-1', 'apartments-4-2'].includes(this.scene)) {
					r = [top, apartments1, apartments2, apartments3, apartments4];
				}

				return Array.from(r);
			},
			_info() {
				var r = {
					title: '',
					content: '',
					cta: {
						label: '',
						href: ''
					}
				};

				// Groups
				if (['top-1', 'top-2', 'top-3', 'beach-playground', 'playground', 'site', 'orangery'].includes(this.scene)) {
					r = this._l.info.site;
				}

				if (['tent-1', 'tent-2', 'tent-3'].includes(this.scene)) {
					r = this._l.info.tents;
				}

				if (['utils-hallway', 'utils-toilet', 'utils-bath', 'utils-bath-3', 'kitchen', 'shop'].includes(this.scene)) {
					r = this._l.info.utils;
				}

				if (['hut-1', 'hut-2'].includes(this.scene)) {
					r = this._l.info.huts;
				}

				if (['apartments-1-1', 'apartments-1-2', 'apartments-1-3', 'apartments-1-4', 'apartments-1-5', 'apartments-1-6', 'apartments-2-1', 'apartments-2-2', 'apartments-2-3', 'apartments-2-4', 'apartments-3-1', 'apartments-3-2', 'apartments-4-1', 'apartments-4-2'].includes(this.scene)) {
					r = this._l.info.apartments;
				}

				return r;
			},
			_places() {
				return [
					{
						label: 'Oversigt',
						areas: [
							{
								thumb: '/img/map_thumb.jpg',
								scenes: [
									'map-west'
								]
							}
						]
					}
				];
			}
		},
		methods: {
			onNavigate(event, navigation) {
				console.log('navigate', event, navigation);
			},
			onInfo(event, info) {
				console.log('info', event, info);
			},
			onGallery(gallery, index) {
				console.log('gallery', gallery, index);
			},
			onNavigationThumbClick(event, value) {
				console.log('navigate thumb', event, value);

				this.scene = value;
				
				// Hide for mobile
				if (screen.width <= 600) {
					this.thu = false;
				}
			}
		},
		mounted() {
			// Preload
			for (var i = 0; i < this._places.length; ++i) {
				for (var j = 0; j < this._places[i].areas.length; ++j) {
					var img = new Image();
					img.src = this._places[i].areas[j];

					this.preloads.push(img);
				}
			}

			const self  = this;

			setTimeout(function () {
				self.thumbs = true;
			}, 500);

			// Hide for mobile
			if (screen.width <= 600) {
				this.inf = false;
				this.thu = false;
			}
		}
	}
</script>

<style lang="scss">
	body {
		overflow: hidden;
	}

	#app {
		font-family: 'Roboto', sans-serif;
		color: white;
		font-weight: 200;
		font-size: 16px;

		& > .logo {
			position: absolute;
			left: 30px;
			top: 30px;
			
			& > div {
				display: inline-block;
				margin: 5px 20px 0 0;
			} 
		}

		& > .copyright {
			position: absolute;
			left: 30px;
			bottom: 30px;
			font-size: 14px;
			color: white;
		}

		& > .icon {
			display: none;
		}
	}

	a {
		text-decoration: none;
		color: #f60;
	}

	@media only screen and (max-width: 600px) {
		#app {
			& > .logo {
				left: 10px;
				top: 10px;

				& > img {
					width: 120px;
				}				
			}

			& > .copyright {
				left: 10px;
				bottom: 10px;
			}

			& > .icon {
				display: block;
				position: absolute;
				fill: white;

				&.menu {
					top: 20px;
					right: 20px;
				}

				&.info {
					bottom: 20px;
					right: 20px;
				}
			}
		}
	}
</style>
